import { ConfirmationNumber } from "@mui/icons-material";
import {
  Typography,
  Box,
  Divider,
  Grid,
  Stack,
  Chip,
} from "@mui/material";

type InfoCardItem = {
  label: string;
  highlight?: boolean;
  winningNumbers?: string[];

};

type InfoCardProps = {
  items: InfoCardItem[];
  maxWidth?: number | string;
};

const InfoCard = ({ items, maxWidth = 500 }: InfoCardProps) => {
  return (
    <Grid item xs={12} px={2}>
      <Box
        sx={{
          p: 4,
          borderRadius: 3,
          backgroundColor: '#111',
          border: '1px solid #222',
          maxWidth,
          margin: '0 auto',
          color: '#f5f5f5',
          boxShadow: '0 0 20px rgba(255, 255, 255, 0.03)',
        }}
      >
        <Stack spacing={2}>
          {items.map((item, index) => !item.winningNumbers ? (
            <Box key={index}>
              <Typography
                variant={index === 0 ? 'h5' : item.highlight ? 'h6' : 'body1'}
                sx={{
                  fontWeight: item.highlight || index === 0 ? 700 : 500,
                  fontStyle: 'italic',
                  textAlign: 'center',
                  letterSpacing: item.highlight || index === 0 ? 1 : 0.5,
                  color: item.highlight ? '#4caf50' : index === 0 ? '#fff' : '#ccc',
                }}
              >
                {item.label}
              </Typography>

              {index < items.length - 1 && (
                <Divider sx={{ borderColor: '#333', my: 1 }} />
              )}
            </Box>
          ): <>
            <Box mb={2}>
              <Typography
                variant={'body1'}
                sx={{
                  fontWeight: 500,
                  fontStyle: 'italic',
                  textAlign: 'center',
                  letterSpacing: 0.5,
                  color: '#ccc',
                }}
              >
                {item.label}
              </Typography>
            </Box>

            <Box display="flex" flexDirection={"column"} flexWrap="wrap" gap={1} mt={2} justifyContent={"space-between"}>
              {item.winningNumbers.map((ticket, idx) => (
                <Chip key={idx} sx={{ color: '#4caf50' }} label={`#${ticket}`} variant="outlined" color="success"  />
              ))}
            </Box>
          </>)}
        </Stack>
      </Box>
    </Grid>
  );
};

export default InfoCard;
